import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as authConstants from '../../../constants/auth';
import * as materialStyles from '../../../constants/materialstyle';

import * as authActionCreators from '../../../actions/auth';
import * as loginActionCreators from '../../../actions/login';
import * as userActionCreators from '../../../actions/user';
let allActionCreators = Object.assign({}, authActionCreators, loginActionCreators, userActionCreators);

import {saveLogin} from '../../../utils/auth';
import {emailValidation, passwordValidation} from '../../../utils/itemValidation';

import TextField from 'material-ui/TextField';


class Login extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      requestPending: false,
      serverError: null,
      email: '',
      password: '',
      errors: {
        email: null,
        password: null,
      }
    };
  }

  changeEmail(evt) {
    this.setState({ email: evt.target.value });
  }

  validateEmail() {
    setTimeout(() => {
      this.setState({ errors: Object.assign({}, this.state.errors, {email: emailValidation(this.state.email)}) });
    }, 100);
  }

  changePassword(evt) {
    this.setState({
      password: evt.target.value
    })
  }

  validatePassword() {
    this.setState({ errors: Object.assign({}, this.state.errors, {password: passwordValidation(this.state.password)}) });
  }

  validateAll() {
    let emailError = emailValidation(this.state.email);
    let passwordError = passwordValidation(this.state.password);

    this.setState({
      errors: Object.assign({}, this.state.errors, {
        email: emailError,
        password: passwordError,
      })
    });
    if(
      emailError === null &&
      passwordError === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();

    if(this.validateAll()) {

      this.setState({
        requestPending: true,
        serverError: null,
      });

      this.props.callLogin(evt.target[0].value, evt.target[1].value)
      .then((respData) => {
        
        this.setState({
          requestPending: false,
          serverError: null,
        });
        saveLogin(respData.auth.auth_token);
        this.props.userSetUser(respData.user);
        this.props.authSave(respData.auth.auth_token, Date.now() + authConstants.LOGOUT_TIME);
        this.context.router.push('/');
      })
      .catch((errorData) => {
        let errorMessage = errorData.message ? errorData.message : 'Cannot connect to Crash of Rhinos';
        this.setState({
          requestPending: false,
          serverError: errorMessage,
        });
      });
    } 
  }

  render() {
    return <div className='Login'>
      <div className='externalWrapper'>
        <div className='loginLogoWrapper'>
          <img src='/img/dd-logo.png' className='centered' />
        </div>
        <div className='externalTitle'>Keep charging, Rhinos!</div>
        {this.state.serverError ? 
          <div className='externalError'>{this.state.serverError}</div> :
          null
        }
        <form 
          className='ResponsiveForm'
          onSubmit={::this.handleSubmit}>
          <div className='formRow'>
            <div className='inputWrapper'>
              <TextField
                value={this.state.email} 
                onChange={::this.changeEmail} 
                onBlur={::this.validateEmail}
                errorText={this.state.errors.email} 
                hintText='rhino@diamondsdirect.com'
                floatingLabelText='Email Address'
                type='email'
                fullWidth={true} 
                underlineFocusStyle={materialStyles.textUnderlineFocusStyle}
                floatingLabelFocusStyle={materialStyles.textFloatingLabelFocusStyle}
                required />
            </div>
          </div>
          <div className='formRow'>
            <div className='inputWrapper'>
              <TextField
                value={this.state.password}
                onChange={::this.changePassword} 
                onBlur={::this.validatePassword}
                errorText={this.state.errors.password}
                hintText='*********'
                floatingLabelText='Password'
                type='password' 
                fullWidth={true} 
                underlineFocusStyle={materialStyles.textUnderlineFocusStyle}
                floatingLabelFocusStyle={materialStyles.textFloatingLabelFocusStyle}
                required />
            </div>
          </div>
          <div className='formRow'>
            <div className='inputWrapper'>
              <button
                className={'loginSubmit actionButton'}
                disabled={this.state.requestPending}
                type='submit'>
                Login
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>;
  }
}
export default Login;

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export const LoginContainer = connect(
  mapStateToProps,
  allActionCreators
)(Login);


// WEBPACK FOOTER //
// ./src/components/views/login/Login.jsx